'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.imageURLWithTransform = imageURLWithTransform;
exports.roomImageURL = roomImageURL;
exports.roomImageURL_v1 = roomImageURL_v1;
exports.roomName = roomName;
exports.spaceName = spaceName;
exports.roomOrSpaceName = roomOrSpaceName;
exports.ownerName = ownerName;
exports.camelCase = camelCase;
exports.snakeCase = snakeCase;
exports.pascalCase = pascalCase;
exports.formatPagerText = formatPagerText;
exports.billName = billName;
exports.isPaid = isPaid;
exports.getFileName = getFileName;
exports.relativeTime = relativeTime;
exports.unreadNumberLabel = unreadNumberLabel;
exports.numberWithComma = numberWithComma;

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reservation = require('../constants/reservation');

var _Room = require('../model/Room');

var _Room2 = _interopRequireDefault(_Room);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function imageURLWithTransform(url) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var urlObject = _url2.default.parse(url);
  var queries = {};
  if (urlObject.search) {
    var searches = urlObject.search.split('&');
    searches.forEach(function (search) {
      var _search$split = search.split('='),
          _search$split2 = _slicedToArray(_search$split, 2),
          key = _search$split2[0],
          value = _search$split2[1];

      queries[key.replace('?', '')] = value;
    });
  }
  if (urlObject.host === 'cdnspacemarket.com' || urlObject.host === 'spacemarket-sandbox.global.ssl.fastly.net') {
    queries.fit = 'crop';
    if (transform.crop === 'pad') queries.fit = 'bounds';
    if (transform.quality) queries.quality = transform.quality;
    if (transform.fetch_format) queries.format = transform.fetch_format;
    if (transform.width) queries.width = transform.width;
    if (transform.height) queries.height = transform.height;
    if (transform.canvasWidth && transform.canvasHeight) {
      queries.canvas = transform.canvasWidth + ',' + transform.canvasHeight;
    }
    queries['bg-color'] = transform.background ? transform.background.replace(/#/g, '') : '9c9c9c';
  } else {
    if (transform.crop === 'pad') queries.da = 'l';else if (transform.crop === 'fill') queries.da = 's';

    queries.ds = 's';
    if (transform.quality) queries.q = transform.quality;
    if (transform.fetch_format) queries.of = transform.fetch_format;
    if (transform.width) {
      queries.dw = transform.width;
      queries.cw = transform.canvasWidth || transform.width;
    }
    if (transform.height) {
      queries.dh = transform.height;
      queries.ch = transform.canvasHeight || transform.height;
    }
    queries.cc = transform.background ? transform.background.replace(/#/g, '') : '9c9c9c';
  }

  var newSearches = [];
  Object.keys(queries).forEach(function (key) {
    newSearches.push(key + '=' + queries[key]);
  });

  urlObject.search = newSearches.join('&');
  return _url2.default.format(urlObject);
}

function roomImageURL(room) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (room.thumbnails && room.thumbnails.results.length > 0) {
    return imageURLWithTransform(room.thumbnails.results[0].url, options);
  }
  return '';
}

function roomImageURL_v1(room) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var isPublicRental = _Room2.default.isPublic(room.rental_room_setting);
  var isPublicStay = _Room2.default.isPublic(room.stay_room_setting);
  var hasRentalAttachments = room.rental_room_setting && Array.isArray(room.rental_room_setting.attachments) && room.rental_room_setting.attachments.length > 0;
  var hasStayAttachments = room.stay_room_setting && Array.isArray(room.stay_room_setting.attachments) && room.stay_room_setting.attachments.length > 0;

  if (isPublicRental && hasRentalAttachments) {
    // rentalが公開済みかつ写真があればrentalの写真
    return imageURLWithTransform(room.rental_room_setting.attachments[0].image, options);
  } else if (isPublicStay && hasStayAttachments) {
    // stayが公開済みかつ写真があればstayの写真
    return imageURLWithTransform(room.stay_room_setting.attachments[0].image, options);
  } else if (hasRentalAttachments || hasStayAttachments) {
    // どちらも公開していない&写真がいずれかはあるなら
    return imageURLWithTransform(hasRentalAttachments ? room.rental_room_setting.attachments[0].image : room.stay_room_setting.attachments[0].image, options);
  }
  // ここまで来たら写真なしのため空文字列を返す
  return '';
}

function roomName(room) {
  if (room) {
    return room.pageTitle || room.name || '';
  }
  return '';
}

function spaceName(room) {
  if (room && room.space && room.space.name) {
    return room.space.name;
  }
  return '';
}

function roomOrSpaceName(room) {
  var roomNameResult = roomName(room);
  if (roomNameResult !== '') {
    return roomNameResult;
  }

  return spaceName(room);
}

function ownerName(owner) {
  return owner.corpName || owner.name || '';
}

function camelCase(str) {
  var formatStr = str.charAt(0).toLowerCase() + str.slice(1);
  return formatStr.replace(/[-_](.)/g, function (match, group1) {
    return group1.toUpperCase();
  });
}

function snakeCase(str) {
  var camel = camelCase(str);
  return camel.replace(/[A-Z]/g, function (s) {
    return '_' + s.charAt(0).toLowerCase();
  });
}

function pascalCase(str) {
  var camel = camelCase(str);
  return camel.charAt(0).toUpperCase() + camel.slice(1);
}

function formatPagerText(pageInfo, perPage) {
  var startCount = 1 + (pageInfo.currentPage - 1) * perPage;
  var endCount = startCount + pageInfo.resultsCount - 1;
  var currentCountDisplay = '';
  var totalCountDisplay = i18n.t('page.search.emptyCount');
  if (pageInfo.totalCount > 0) {
    currentCountDisplay = i18n.t('page.search.displayCount', {
      min: startCount,
      max: endCount
    });
    totalCountDisplay = i18n.t('page.search.totalCount', {
      count: pageInfo.totalCount
    });
  }

  return {
    currentCountDisplay: currentCountDisplay,
    totalCountDisplay: totalCountDisplay
  };
}

function billName(reservation) {
  if (reservation.status === _reservation.STATUS.POSTPAY) {
    return 'ー';
  } else if (reservation.status === _reservation.STATUS.REQUESTED) {
    return i18n.t('page.shared.l_00021');
  } else if (reservation.status === _reservation.STATUS.CONFIRMED) {
    return i18n.t('page.shared.l_00071');
  } else if (reservation.status === _reservation.STATUS.PAID || reservation.status === _reservation.STATUS.REFUNDED) {
    return i18n.t('page.shared.l_00020');
  }

  return '';
}

function isPaid(reservation) {
  return reservation.status === _reservation.STATUS.PAID || reservation.status === _reservation.STATUS.REFUNDED;
}

function getFileName(url) {
  var strings = url.match('.+/(.+?)([?#;].*)?$');
  return strings ? strings[1] : '';
}

function relativeTime(datetime) {
  var m = (0, _moment2.default)(datetime, 'YYYY-MM-DD HH:mm Z', 'ja');
  return m.fromNow();
}

function unreadNumberLabel(newsNumber) {
  var label = '';
  if (newsNumber && newsNumber > 0) {
    label = newsNumber;
    if (newsNumber > 99) label = '99+';
  }
  return label;
}

function numberWithComma(num) {
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/helpers/format.js
// module id = 36
// module chunks = 0